/* unplugin-vue-components disabled */import { render } from "./style2.vue?vue&type=template&id=dba59cea&scoped=true"
import script from "./style2.vue?vue&type=script&lang=js"
export * from "./style2.vue?vue&type=script&lang=js"

import "./style2.vue?vue&type=style&index=0&id=dba59cea&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dba59cea"]])

export default __exports__